<div class="file">
  <div class="file-container">
    <button
      class="file-btn"
      (click)="handleClick('open', feedbackMediaProps().index)"
    >
      <img
        class="file-img"
        alt=""
        width="60"
        height="60"
        [src]="feedbackMediaProps().url"
      >
    </button>
  </div>
</div>
